import { Flex } from 'foundations-components/components/Flex';
import { PurchaseMotionCTA } from 'purchase-motions-components/components/PurchaseMotionCTA/PurchaseMotionCTA';
import { usePurchaseMotions } from 'purchase-motions-components/hooks/usePurchaseMotions';
import { getTrackingDataFromUpgradeConfig } from '../../_core/utils/getTrackingDataFromUpgradeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const ValuePropModalFooter = ({
  upgradeConfig
}) => {
  const trackingData = getTrackingDataFromUpgradeConfig(upgradeConfig);
  const {
    purchaseMotions
  } = usePurchaseMotions({
    location: 'UPGRADE_MODAL',
    apiName: upgradeConfig.bestFitApiNameForPurchase
  });
  return /*#__PURE__*/_jsx(Flex, {
    gap: "200",
    paddingBlockStart: "600",
    children: purchaseMotions.slice(0, 2).map((purchaseMotion, index) => /*#__PURE__*/_jsx(PurchaseMotionCTA, {
      purchaseMotion: purchaseMotion,
      apiName: upgradeConfig.bestFitApiNameForPurchase,
      trackingData: trackingData,
      upgradeConfig: upgradeConfig,
      uiButtonProps: {
        use: index === 0 ? 'primary' : 'secondary'
      },
      isUpgradePoint: true
    }, purchaseMotion))
  });
};
export default ValuePropModalFooter;